import { useAutoSave } from './use-auto-save';
import { WritingSaveData } from '@/types/writing';

export function useEssayAutoSave({
  writingData,
  user,
  initialEssayId,
  handleSave,
  debounceMs,
}: {
  writingData: WritingSaveData;
  user: { uid: string } | null | undefined;
  initialEssayId?: string | null;
  handleSave: (data: WritingSaveData, id?: string | null) => Promise<string>;
  debounceMs: number;
}) {
  const { saveStatus, currentEssayId } = useAutoSave({
    data: writingData,
    onSave: handleSave,
    userId: user?.uid,
    initialEssayId,
    debounceMs,
  });

  return {
    saveStatus,
    currentEssayId,
  };
}
